// extracted by mini-css-extract-plugin
export default {"lista":"HistoricoComponente_lista__QLw2x"};